import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class UploadMissedActionDataValidationHistoryService {
  private options = { headers: new HttpHeaders().set('enctype', 'multipart/form-data') };
  constructor(
    private http: HttpClient,
    private configService: ConfigService) { }

    getAPI =  "/api/gtmisdactndatavldtnlst";

    Get(pagination: any) {
      return this.http.post(this.getAPI, pagination);
    }
}
